<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import VDataTableQuotes from "@/components/VDataTable/VDataTableQuotes.vue";
import QuotesModal from "@/components/Quotes/QuotesModal.vue";
import ComponentsKeys from "@/mixins/ComponentsKeys";
import _ from "lodash";
import VMenuContext from "@/components/commonComponents/VMenuContext.vue";
import VMenuItem from "@/components/commonComponents/VMenuItem.vue";

export default {
    name: "ProjectsQuotes",
    components: {
        VMenuItem,
        VMenuContext,
        QuotesModal,
        VDataTableQuotes,
        AjaxLoad,
    },
    mixins: [
        ComponentsKeys,
    ],
    data() {
        return {
            response: null,
            componentsKeys: {
                quotesModal: this.getRandomKey('quotesModal')
            },
        };
    },
    props: {
        idProject: {
            type: String,
        },
        footerProps: {
            type: Object,
            default: () => ({itemsPerPageOptions: [20]}),
        },
        quotesFilter: {
            type: [Function, Object],
        },
        isModal: {
            type: Boolean,
        },
    },
    computed: {
        quotes() {
            return this.response?.data || [];
        },
        permissions() {
            return this.response?.meta?.permissions || {};
        },
        filteredQuotes() {
            return this.quotesFilter ? _.filter(this.quotes, this.quotesFilter) : this.quotes;
        },
    },
    methods: {
        doShowModal(id, isCopy = false) {
            this.$refs.quotesModal.show(id, {}, isCopy)
                .then((result) => {
                    if (result !== false) {
                        this.$refs.ajax.load();
                    }
                })
                .finally(() => {
                    this.updateComponentKey('quotesModal');
                });
        },
        onDblClickRow(e, {item}) {
            if (this.$listeners['dblclick:row']) {
                this.$emit('dblclick:row', e, {item});
                return;
            }
            this.doShowModal(item.id);
        },
        onClickAdd() {
            this.doShowModal(0);
        },
        onClickCopy(item) {
            this.doShowModal(item.id, true);
        },
        onClickOpen(item) {
            this.doShowModal(item.id);
        },
    },
}
</script>

<template>
    <ajax-load
        ref="ajax"
        v-model="response"
        :active="idProject || false"
        :url="$apiUrl.getQuotesUrl({id_project: idProject})"
        :transform="response => response.data"
        v-slot="{resolved, active}"
    >
        <v-card>
            <v-data-table-quotes
                :loading="!resolved && !!active"
                :items="filteredQuotes"
                :footer-props="footerProps"
                :custom-permissions="permissions"
                @dblclick:row="onDblClickRow"
                @[!isModal?`click:add`:null]="onClickAdd"
                @click:reload="() => $refs.ajax.load()"
                @contextmenu:row="(...params) => $refs.contextMenu.show(...params)"
                heading="Цитаты"
                search=""
                filter
                with-toolbar
            ></v-data-table-quotes>

            <v-menu-context
                ref="contextMenu"
                v-slot="{item}"
            >
                <v-menu-item @click="onClickAdd" :disabled="!permissions?.canCreate">Добавить</v-menu-item>
                <v-menu-item @click="onClickOpen(item)" :disabled="!item?.permissions?.canRead">Открыть</v-menu-item>
                <v-menu-item @click="onClickCopy(item)" :disabled="!permissions?.canCreate">Копировать</v-menu-item>
            </v-menu-context>

            <quotes-modal
                ref="quotesModal"
                :key="componentsKeys.quotesModal"
                :id-project="idProject"
            ></quotes-modal>
        </v-card>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>
